import React, { useState } from "react";
import SettingsIcon from "../../assets/svgIcons/settings-icon.svg";
import DisconnectIcon from "../../assets/svgIcons/disconnect-icon.svg";
import RefreshIcon from "../../assets/svgIcons/refresh-icon.svg";
import AddIcon from "../../assets/svgIcons/add-circle-icon-black.svg";
import NoSync from "../../assets/svgIcons/no_sync.svg";
import { Button } from "./design-system/Button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./design-system/Dropdown";
import DisconnectModal from "./DisconnectModal";
import type { IntegrationAPIResponse } from "../IntegrationModal";

export default function SettingsDropdown({
  cancelSourceItemsSync,
  dataSource,
  isResyncingDataSource,
  isRevokingDataSource,
  resyncDataSource,
  revokeDataSource,
  sendOauthRequest,
  showSelectMorePages,
}: {
  revokeDataSource: () => Promise<void>;
  isRevokingDataSource: boolean;
  resyncDataSource: () => Promise<void>;
  isResyncingDataSource: boolean;
  showSelectMorePages: boolean;
  sendOauthRequest: (
    mode?: string,
    dataSourceId?: number,
    extraParams?: object,
  ) => Promise<void>;
  dataSource: IntegrationAPIResponse | null;
  cancelSourceItemsSync: (id?: number) => void;
}) {
  const [showDisconnectModal, setShowDisconnectModal] =
    useState<boolean>(false);

  return (
    <>
      <DisconnectModal
        isOpen={showDisconnectModal}
        onOpenChange={setShowDisconnectModal}
        revokeDataSource={revokeDataSource}
      />
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            className="cc-rounded-xl cc-shrink-0 cc-px-0 cc-w-8"
            size="sm"
            variant="gray"
          >
            <img
              alt="User Plus"
              className="cc-h-[18px] cc-w-[18px] cc-shrink-0 dark:cc-invert-[1] dark:cc-hue-rotate-180"
              src={SettingsIcon}
            />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="cc-w-[208px]">
          <DropdownMenuGroup>
            <DropdownMenuItem
              className="hover:cc-bg-surface-surface_1 cc-justify-between dark:cc-text-dark-text-white"
              onClick={() => {
                !isRevokingDataSource && setShowDisconnectModal(true);
              }}
            >
              Disconnect account
              <img
                alt="Disconnect Icon"
                className="cc-h-[14px] cc-w-[14px] cc-shrink-0 dark:cc-invert-[1] dark:cc-hue-rotate-180"
                src={DisconnectIcon}
              />
            </DropdownMenuItem>
            <DropdownMenuItem
              className="hover:cc-bg-surface-surface_1 cc-justify-between dark:cc-text-dark-text-white"
              onClick={async () => !isResyncingDataSource && resyncDataSource()}
            >
              Re-sync account
              <img
                alt="Refresh Icon"
                className="cc-h-[14px] cc-w-[14px] cc-shrink-0 dark:cc-invert-[1] dark:cc-hue-rotate-180"
                src={RefreshIcon}
              />
            </DropdownMenuItem>
            {showSelectMorePages && dataSource?.id ? (
              <DropdownMenuItem
                className="hover:cc-bg-surface-surface_1 cc-justify-between dark:cc-text-dark-text-white"
                onClick={async () => sendOauthRequest("UPLOAD", dataSource?.id)}
              >
                Select more pages
                <img
                  alt="Add Icon"
                  className="cc-h-[14px] cc-w-[14px] cc-shrink-0 dark:cc-invert-[1] dark:cc-hue-rotate-180"
                  src={AddIcon}
                />
              </DropdownMenuItem>
            ) : null}
            {dataSource?.sync_status == "SYNCING" ? (
              <DropdownMenuItem
                className="hover:cc-bg-surface-surface_1 cc-justify-between dark:cc-text-dark-text-white"
                onClick={() => cancelSourceItemsSync()}
              >
                Cancel sync
                <img
                  alt="Add Icon"
                  className="cc-h-[14px] cc-w-[14px] cc-shrink-0 dark:cc-invert-[1] dark:cc-hue-rotate-180"
                  src={NoSync}
                />
              </DropdownMenuItem>
            ) : null}
          </DropdownMenuGroup>
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
}
